import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Grid } from '@mui/material';
import { FileUpload } from 'components/FileUpload/layout';
import Modal, { IModalProps } from 'components/Modal';
import GrowTransition from 'components/Modal/animations/grow';
import { Form, Formik } from 'formik';
import reportAddFileModalValidation from 'modules/Report/utils/modalValidation';

import SearchField from '@common/components/Form/SearchField';
import TextField from '@common/components/Form/TextField';
import { type ReportUploadFileFormValues } from '@common/modules/Report/types';

interface PropsType extends Omit<IModalProps, 'title'> {
	handleSubmit: (data: ReportUploadFileFormValues) => void;
	initialValues: ReportUploadFileFormValues;
}

const options = [
	{ value: 'for active participation', label: 'For active participation' },
	{ value: 'English', label: 'English' },
	{ value: 'Biology', label: 'Biology' },
	{ value: 'Chemistry', label: 'Chemistry' },
	{ value: 'mentor', label: 'Mentoring support' },
];

function ReportUploadFileModal({ handleSubmit, initialValues, ...props }: PropsType) {
	const [filteredOptions, setFilteredOptions] = useState(options);

	const handleSearch = (searchValue: string) => {
		const updatedOptions = options.filter((option) =>
			option.label.toLowerCase().includes(searchValue.toLowerCase()),
		);
		setFilteredOptions(updatedOptions);
	};

	const { t } = useTranslation();

	return (
		<Modal
			PaperProps={{
				sx: {
					maxWidth: '500px',
				},
			}}
			title={t('report.achievements.addFileModal.title')}
			TransitionComponent={GrowTransition}
			transitionDuration={500}
			{...props}
		>
			<Formik
				onSubmit={handleSubmit}
				initialValues={initialValues}
				validationSchema={reportAddFileModalValidation({ t })}
			>
				<Form>
					<Grid container gap="16px" direction="column">
						<TextField
							name="name"
							placeholder={t('report.achievements.addFileModal.placeholderName')}
							sx={{ '& .MuiInputBase-input': { boxShadow: 'none' } }}
						/>
						<SearchField
							name="type"
							label=""
							placeholder={t('report.achievements.addFileModal.placeholderType')}
							data={filteredOptions}
							itemLabelKey="label"
							onSearch={handleSearch}
						/>
						<FileUpload
							maxSize={100}
							name="file"
							acceptFiles="HOMEWORK"
							formatsText="PDF, PNG or JPG (max. 100MB)"
						/>
						<Button type="submit" variant="contained" fullWidth sx={{ borderRadius: '10px' }}>
							{t('shared.save')}
						</Button>
					</Grid>
				</Form>
			</Formik>
		</Modal>
	);
}

export default ReportUploadFileModal;
